/**
 * Remove any dashes, spaces or special characters from name and replace with an underscore
 * @param {string} name value to convert to slug
 * @return {string} converted value
 */

const createSuggestedSlug = (name: string): string =>
  name
    .replace(/[&\/\\#,+()$~%.'":*?<>{}!@^=]/g, '')
    .replace(/-|\s/g, '_')
    .toLowerCase();

export default createSuggestedSlug;
